import { render, staticRenderFns } from "./EmailTranscriptModal.vue?vue&type=template&id=0c40797e&scoped=true&"
import script from "./EmailTranscriptModal.vue?vue&type=script&lang=js&"
export * from "./EmailTranscriptModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailTranscriptModal.vue?vue&type=style&index=0&id=0c40797e&prod&lang=scss&scoped=true&"
import style1 from "./EmailTranscriptModal.vue?vue&type=style&index=1&id=0c40797e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c40797e",
  null
  
)

export default component.exports